import { Box, SxProps, Theme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import useComponentVisible from '../../../hooks/useComponentVisible';

type DropdownItem = {
  label: string;
  onClick: () => void;
};

type DropdownProps = {
  title: string;
  data: DropdownItem[];
  sx?: SxProps<Theme>;
};

const Dropdown = ({ title, data, sx }: DropdownProps) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  return (
    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%', ...sx }}>
      <Box ref={ref} sx={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%' }}>
        <Box
          component="button"
          onClick={() => setIsComponentVisible(!isComponentVisible)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'white',
            fontFamily: 'inherit',
            fontSize: 18,
            fontWeight: 400,
            textTransform: 'uppercase',
            padding: 0,
          }}
        >
          <Box>{title}</Box>
          <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 21 }}>
            {isComponentVisible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </Box>
        </Box>

        {isComponentVisible && (
          <Box
            sx={{
              position: 'absolute',
              top: '100%',
              right: 0,
              width: 120,
              zIndex: 40,
            }}
          >
            {data.map((item, index) => (
              <Box
                key={index}
                onMouseDown={item.onClick}
                sx={{
                  backgroundColor: 'rgba(0,0,0,0.73)',
                  borderBottomLeftRadius: index === data.length - 1 ? 6 : 0,
                  borderBottomRightRadius: index === data.length - 1 ? 6 : 0,
                  color: 'white',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'filter 200ms ease-in-out',
                  '&:hover': {
                    filter: 'brightness(110%)',
                  },
                }}
              >
                {item.label}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Dropdown;
